import { CountrySelect } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingComplianceDetails } from '../../../../../../../../hooks/missingComplianceDetails/useMissingComplianceDetails'
import { useMissingCustomerDetailsForm } from '../../../../../../contexts/missingCustomerDetailsFormContext'
import { CustomerAddressInputFieldProps } from '../../types/customerAddressInputFieldProps'

type CustomerCountryProps = CustomerAddressInputFieldProps

export const CustomerCountry = ({ isDisabled = false }: CustomerCountryProps): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCustomerDetailsForm: { FormItem },
  } = useMissingCustomerDetailsForm()
  const { isMissingCustomerEInvoicingAddress } = useMissingComplianceDetails()

  // Allowing a country change here when the customer already has an e-invoicing address would carry forward a stale e-invoicing address.
  // In case "Send as e-invoice" finalize option was chosen, the next modal step would be SendAsEInvoiceModal and submitting without
  // updating e-invoicing address would likely cause a validation error as it may be in the wrong format for the new country.
  const isCountrySelectDisabled = isDisabled || !isMissingCustomerEInvoicingAddress

  return (
    <FormItem
      label={t('external_invoices.missing_customer_compliance_details.modal.form.field.address.country.label')}
      name="address.country"
      render={({ field: { onChange, value, ...rest } }) => (
        <CountrySelect
          {...rest}
          disabled={isCountrySelectDisabled}
          dropdownSize="fitTrigger"
          onSelect={onChange}
          selectedId={value}
          size="sm"
        />
      )}
    />
  )
}
